import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = ["data-testid"];
const _hoisted_3 = { class: "text-sm text-(--colors-text-body)" };
import { Button } from "@eudonet/opal";
/** Loading / failed / loaded states of one block that fetches on its own, with a retry. */
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsBlockState',
    props: {
        isLoading: { type: Boolean },
        loadError: { type: Boolean },
        errorKey: {},
        testId: {}
    },
    emits: ["retry"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            return (__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "flex items-center gap-2 py-6 text-sm text-(--colors-text-body-subtle)",
                    "data-testid": `${__props.testId}-loading`
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", {
                        class: "ri-loader-4-line animate-spin text-xl",
                        "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("workspace.settings.loading")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_1))
                : (__props.loadError)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "flex flex-col items-start gap-3 py-2",
                        "data-testid": `${__props.testId}-error`
                    }, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(__props.errorKey)), 1 /* TEXT */),
                        _createVNode(_unref(Button), {
                            variant: "secondary",
                            label: _ctx.$t('workspace.settings.retry'),
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('retry')))
                        }, null, 8 /* PROPS */, ["label"])
                    ], 8 /* PROPS */, _hoisted_2))
                    : _renderSlot(_ctx.$slots, "default", { key: 2 });
        };
    }
});
